import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Psychiatrist Pages
import PsychiatristDashboard from '../pages/psychiatrist/Dashboard';
import PsychiatristCalendar from '../pages/psychiatrist/Calendar';
import Settings from '../pages/psychiatrist/Settings';
import Patients from '../pages/psychiatrist/Patients';
import Layout from '../pages/psychiatrist/Layout';
import Sessions from '../pages/psychiatrist/Sessions';
import Assessments from '../pages/psychiatrist/Assessments';
// import BasicInfo from '../pages/psychiatrist/BasicInfo';

import Prescriptions from '../pages/psychiatrist/Prescriptions';

import Assessment from '../pages/patient/Assessment';

// Coming Soon Fallback
import ComingSoon from '../components/ComingSoon';

const PsychiatristRoutes = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<PsychiatristDashboard />} />
        <Route path="calendar" element={<PsychiatristCalendar />} />
        <Route path="settings" element={<Settings />} />
        <Route path="patients" element={<Patients />} />
        <Route path="session" element={<Sessions />} />
        <Route path="assessment" element={<Assessments />} />
        {/* <Route path="basic-info" element={<BasicInfo />} /> */}

        <Route path="prescriptions" element={<Prescriptions />} />
      
        <Route path="/patient/assessment/:assessmentId" element={<Assessment />} />

        {/* Fallback route */}
        <Route
          path="*"
          element={
            <ComingSoon
              title="Coming Soon"
              subtitle="Psychiatrist feature under development"
              description="This psychiatrist feature is currently being developed. Please check back soon for updates!"
            />
          }
        />
      </Routes>
    </Layout>
  );
};

export default PsychiatristRoutes;
